@if (!isHandset) {
  <div class="session-page" (window:resize)="onResize($event)">
    <div class="session-titles">
      <div class="session-titles-header">
        <h3>Menu Provider</h3>
        <!-- <button matButton mat-button (click)="showMenu = !showMenu;"><mat-icon>+</mat-icon></button> -->
      </div>
      <div class="session-titles-content" >
        <h5>Dashboard</h5>
        <h6><a routerLink ="/provider/dashboard">Tableau de bord</a> </h6>
        <mat-divider></mat-divider>
        <h5>Parc</h5>
        <h6><a [routerLink]="['/provider/park']">Voir mes véhicules</a></h6>
        <h6><a [routerLink]="['/provider/post-new-car']">Poster un véhicule</a></h6>
        <mat-divider></mat-divider>
        <h5>Ventes</h5>
        <h6><a [routerLink]="['/provider/buy-offer']">Mes offres achat</a></h6>
        @if (dealerData.buyProvider) {
          <h6><a [routerLink]="['/provider/buy-ongoing']">Ventes en cours </a></h6>
        }
        @if (dealerData.buyProvider) {
          <h6><a [routerLink]="['/provider/buy-completed']">Ventes conclues</a></h6>
        }
        <mat-divider></mat-divider>
        <h5>Locations</h5>
        <h6><a [routerLink]="['/provider/rent-offer']">Mes offres location</a></h6>
        @if (dealerData.rentProvider) {
          <h6><a [routerLink]="['/provider/rent-bookings']">Réservations</a></h6>
        }
        @if (dealerData.rentProvider) {
          <h6><a [routerLink]="['/provider/rent-ongoing']">Locations en cours</a></h6>
        }
        @if (dealerData.rentProvider) {
          <h6><a [routerLink]="['/provider/rent-completed']">Locations conclues</a></h6>
        }
        <mat-divider></mat-divider>
        <h5>Entretien</h5>
        <h6><a [routerLink]="['/provider/servicing-offer']">Mes offres entretien</a></h6>
        @if (dealerData.keepProvider) {
          <h6><a [routerLink]="['/provider/servicing-bookings']">Entretiens planifiés</a></h6>
        }
        @if (dealerData.keepProvider) {
          <h6><a [routerLink]="['/provider/servicing-ongoing']">Entretiens en cours</a></h6>
        }
        @if (dealerData.keepProvider) {
          <h6><a [routerLink]="['/provider/servicing-completed']">Entretiens conclus</a></h6>
        }
        <mat-divider></mat-divider>
        <h5>Communication</h5>
        <h6><a [routerLink]="['/provider/appointments']">Mes rendez-vous </a></h6>
        <h6><a [routerLink]="['/provider/conversations']">Mes conversations</a></h6>
        <h6><a [routerLink]="['/provider/notifications']">Notifications </a></h6>
        <mat-divider></mat-divider>
        <h5>Compte</h5>
        <!-- <h6><a [routerLink]="['/provider/my-owners']">Mes proprio </a></h6>
        <h6><a [routerLink]="['/provider/account']">Mon profil</a></h6>  -->
        <h6><a [routerLink]="['/provider/account']">Mes infos compte</a></h6>
        <h6><a [routerLink]="['/provider/account-settings']">Paramètres compte</a></h6>
        <h6><a [routerLink]="['/provider/contracts']">Mes contrats</a></h6>
        <h6><a [routerLink]="['/provider/public']" [queryParams]="{id: currentUserId}">Mon profil public</a></h6>
        <h6><a [routerLink]="['/provider/become-partner']">Devenir partenaire</a></h6>
        <!-- <h6><a [routerLink]="['/owner']">Mon profil propriétaire </a></h6> -->
        <h6><a [routerLink]="['/customer']">Mon Compte Client </a></h6>
      </div>
    </div>
    <div class="session-content">
      <router-outlet></router-outlet>
      @if ((fetchingResults$ | async)!) {
        <p style="text-align:center">
          <mat-spinner style="margin:0 auto;"  [diameter]="40"></mat-spinner>
        </p>
      }
    </div>
  </div>
}


@if (isHandset) {
  <div class="session-page" (window:resize)="onResize($event)" >
    <mat-drawer-container class="sidenav-container" autosize>
      <mat-drawer #drawer class="sidenav-menu" mode="over" position="end">
        <div class="session-titles-header">
          <h3>Menu Provider &nbsp;&nbsp;&nbsp;</h3>
          <button mat-icon-button (click)="drawer.toggle()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <h5>Dashboard</h5>
        <h6><a routerLink ="/provider/dashboard">Tableau de bord</a> </h6>
        <mat-divider></mat-divider>
        <h5>Parc</h5>
        <h6><a [routerLink]="['/provider/park']">Voir mes véhicules</a></h6>
        <h6><a [routerLink]="['/provider/post-new-car']">Poster un véhicule</a></h6>
        <mat-divider></mat-divider>
        <h5>Ventes</h5>
        <h6><a [routerLink]="['/provider/buy-offer']">Mes offres achat</a></h6>
        @if (dealerData.buyProvider) {
          <h6><a [routerLink]="['/provider/buy-ongoing']">Ventes en cours </a></h6>
        }
        @if (dealerData.buyProvider) {
          <h6><a [routerLink]="['/provider/buy-completed']">Ventes conclues</a></h6>
        }
        <mat-divider></mat-divider>
        <h5>Locations</h5>
        <h6><a [routerLink]="['/provider/rent-offer']">Mes offres location</a></h6>
        @if (dealerData.rentProvider) {
          <h6><a [routerLink]="['/provider/rent-bookings']">Réservations</a></h6>
        }
        @if (dealerData.rentProvider) {
          <h6><a [routerLink]="['/provider/rent-ongoing']">Locations en cours</a></h6>
        }
        @if (dealerData.rentProvider) {
          <h6><a [routerLink]="['/provider/rent-completed']">Locations conclues</a></h6>
        }
        <mat-divider></mat-divider>
        <h5>Entretien</h5>
        <h6><a [routerLink]="['/provider/servicing-offer']">Mes offres entretien</a></h6>
        @if (dealerData.keepProvider) {
          <h6><a [routerLink]="['/provider/servicing-bookings']">Entretiens planifiés</a></h6>
        }
        @if (dealerData.keepProvider) {
          <h6><a [routerLink]="['/provider/servicing-ongoing']">Entretiens en cours</a></h6>
        }
        @if (dealerData.keepProvider) {
          <h6><a [routerLink]="['/provider/servicing-completed']">Entretiens conclus</a></h6>
        }
        <mat-divider></mat-divider>
        <h5>Communication</h5>
        <h6><a [routerLink]="['/provider/appointments']">Mes rendez-vous </a></h6>
        <h6><a [routerLink]="['/provider/conversations']">Mes conversations</a></h6>
        <h6><a [routerLink]="['/provider/notifications']">Notifications </a></h6>
        <mat-divider></mat-divider>
        <h5>Compte</h5>
        <!-- <h6><a [routerLink]="['/provider/my-owners']">Mes proprio </a></h6>
        <h6><a [routerLink]="['/provider/account']">Mon profil</a></h6>  -->
        <h6><a [routerLink]="['/provider/account']">Mes infos compte</a></h6>
        <h6><a [routerLink]="['/provider/account-settings']">Paramètres compte</a></h6>
        <h6><a [routerLink]="['/provider/contracts']">Mes contrats</a></h6>
        <h6><a [routerLink]="['/provider/public']" [queryParams]="{id: currentUserId}">Mon profil public</a></h6>
        <h6><a [routerLink]="['/provider/become-partner']">Devenir partenaire</a></h6>
        <!-- <h6><a [routerLink]="['/owner']">Mon profil propriétaire </a></h6> -->
        <h6><a [routerLink]="['/customer']">Mon Compte Client </a></h6>
      </mat-drawer>
      <div class="sidenav-page">
        <div class="session-top">
          <h3>Menu Provider &nbsp;&nbsp;&nbsp;</h3>
          <button mat-icon-button (click)="drawer.toggle()">
            <mat-icon>menu</mat-icon>
          </button>
        </div>
        <div class="session-content">
          <router-outlet></router-outlet>
          @if ((fetchingResults$ | async)!) {
            <p style="text-align:center">
              <mat-spinner style="margin:0 auto;"  [diameter]="40"></mat-spinner>
            </p>
          }
        </div>
      </div>
    </mat-drawer-container>
  </div>
}


<!--
<div class="session-page">
  <div class="session-titles" *ngIf="false">
    <h3>Menu Provider</h3>
    <h5>Parc</h5>
    <button mat-button class="simple-button" [routerLink]="'dashboard'">
      Tableau de bord
    </button>

    <button mat-button class="simple-button" [routerLink]="'park'">
      Parc sous gestion
    </button>

    <h5>Communications</h5>
    <button mat-button class="simple-button" [routerLink]="'appointments'">
      Mes rendez-vous
    </button>

    <button mat-button class="simple-button" [routerLink]="'conversations'">
      Mes conversations
    </button>


    <h5>Compte</h5>
    <button mat-button class="simple-button" [routerLink]="'my-owners'">
      Mes proprio
    </button>

    <button mat-button class="simple-button" [routerLink]="'contracts'">
      Mes contrats
    </button>

    <button mat-button class="simple-button" [routerLink]="'become'">
      Devenir partenaire
    </button>

    <button mat-button class="simple-button" [routerLink]="'public'" [queryParams]="{ id: ''+this.currentUserId }">
      Mon profil public
    </button>
  </div>

  <div class="session-titles" *ngIf="true">

    <h3>Menu Provider</h3>

    <h5>Dashboard</h5>
    <h6><a routerLink ="/provider/dashboard">Dashboard</a> </h6>

    <mat-divider></mat-divider>
    <h5>Parc</h5>
    <h6><a [routerLink]="['/provider/park']">Voir mes voitures</a></h6>
    <h6><a [routerLink]="['/provider/post-new-car']">Poster une voiture</a></h6>

    <mat-divider></mat-divider>
    <h5>Ventes</h5>
    <h6><a [routerLink]="['/provider/buy']">Ventes en cours </a></h6>
    <h6><a [routerLink]="['/provider/buy']">Ventes conclues</a></h6>

    <mat-divider></mat-divider>
    <h5>Locations</h5>
    <h6><a [routerLink]="['/provider/rent']">Réservations</a></h6>
    <h6><a [routerLink]="['/provider/rent']">Locations en cours</a></h6>
    <h6><a [routerLink]="['/provider/rent']">Locations conclues</a></h6>

    <mat-divider></mat-divider>
    <h5>Communication</h5>
    <h6><a [routerLink]="['/provider/appointments']">Mes rendez-vous </a></h6>
    <h6><a [routerLink]="['/provider/conversations']">Mes conversations</a></h6>
    <h6><a [routerLink]="['/provider/notifications']">Notifications </a></h6>

    <mat-divider></mat-divider>
    <h5>Compte</h5>
    <h6><a [routerLink]="['/provider/my-owners']">Mes proprio </a></h6>
    <h6><a [routerLink]="['/provider/contracts']">Mes contrats</a></h6>
    <h6><a [routerLink]="['/provider/account']">Mon profil</a></h6>

    <h6><a [routerLink]="['/provider/public']" [queryParams]="{id: currentUserId}">Mon profil public</a></h6>
    <h6><a [routerLink]="['/owner']">Mon profil propriétaire </a></h6>

  </div>

  <div class="session-content">

    <router-outlet></router-outlet>

    <p *ngIf="(fetchingResults$ | async)!" style="text-align:center">
      <mat-spinner style="margin:0 auto;"  [diameter]="40"></mat-spinner>
    </p>

  </div>
</div> -->
